
import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button, IconButton, Modal, Box, TextField, InputAdornment, Stack, Backdrop, CircularProgress } from "@mui/material";
import "../Styles/AdminListings.css";
import { careFacilityColumns, exportCareFacilityColumns } from "./careFacilitiesColumns";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCareFacilityList, deleteCareFacility } from '../../common/constants/globalconstants';
import { updateActiveCounts } from "../../../action";
import { Check, Search } from "@mui/icons-material";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import ErrorModal from "../../common/ErrorModal";
import axiosInstance from "../../common/AxiosInterceptor";
import ActiveCounts from "../common/ActiveCounts";


//#F2F3F5 alternate color

const customStyle = {
	table:{
		style: {
			border:'1px solid #DEDEDE', 
			borderRadius:'5px',
			justifyContent:'center'
		}
	},
	header: {
		style:{
			color: '#193062',
			whiteSpace: 'nowrap',
			overflow: 'visible',
			textOverflow: 'unset',
		}
	},
	headRow: {
		style: {
			border:"none",
			backgroundColor: '#CDD4DC',
			fontWeight: 'bold',
            color:'#002d82',
            fontSize:'14px',
            whiteSpace: 'nowrap',
			overflow: 'visible',
			textOverflow: 'unset',
		}
	},
	rows: {
		stripedStyle: {
			backgroundColor: '#F2F3F5',
			justifyContent:'center',
			alignItems:"center",
			align:"center",
			float:"center"
		}
	}
}

const style = {
    position: 'absolute' ,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width:'40%',
    padding:'20px !important',
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxHeight:'80%',
    alignItems:'center',
    display:'flex',
    flexDirection:'column',
    gap:'10px',
	borderRadius:"10px"
};

function CareFacilityListings() {
    const navigate = useNavigate();	
	const dispatch = useDispatch();
    const [records, setRecords] = useState([]);
	//const [originalData, setOriginalData] = useState([]);
	const [careFacilities, setCareFacilities] = useState([]);
	const [loading, setloading] = useState(false);
	const [open, setOpen] = useState(false);
	const [deleteOpen, setDeleteOpen] = useState(false); //to be deleted
	const [warning, setWarning] = useState(false);
	const [resetPagination, setRstPagination] = useState(false);
	const [deleteRow, setDeleteRow] = useState({});
	const [facilityName, setFacilityName] = useState("");
	const [message, setMessage] = useState("");
	const [disableBtns, setDisableBtns] = useState(false);
	const [errormodalopen, seterrormodalOpen] = React.useState(false);
	const storeuser = useSelector(state => state.storeuser);
	const userAccessRole = useSelector((state)=> state.userAccessRole);

	useEffect( () => {
		fetchCareFacilityDetails();		
	}, []);

	const fetchCareFacilityDetails = async() => {
		setloading(true);
		try{
		const resp = await axiosInstance.get(`${getCareFacilityList}`);
			if(resp.data.isSuccess){
			setRecords(resp.data.result.careFacilityList);
			//setOriginalData(resp.data.result.careFacilityList);
			setCareFacilities(resp.data.result.careFacilityList);
			const {numberofActiveUsers, numberofCareFaclities } = resp.data.result;
			dispatch(updateActiveCounts({numberofActiveUsers, numberofCareFaclities}));
			}
			else if(!resp.data.isSuccess){
				seterrormodalOpen(true);
			}
			setloading(false);
		}
		catch(err) {
			setloading(false);
			seterrormodalOpen(true);
			console.log(err.message);
		}
	}

	const handleClose = () => {
		//setDisableBtns(true);
        setOpen(false);
    }

	const handleDeleteClose = () => {
		setDisableBtns(false);
        setDeleteOpen(false);
		fetchCareFacilityDetails();
    }

	const handleDelete = (row) => {
		setFacilityName(row.companyName);
		if(row.canDelete === false){
			setWarning(true);
			setMessage("Please delete the user(s) before deleting the Care Facility");
		}
		else{
			setWarning(false);
		}
		setOpen(true);
		setDeleteRow(row);
	}

	const handleDeleteCareFacility = async() => {
	try{
		setDisableBtns(true);
		const request = getDeleteRequestObj();
		const response = await axiosInstance.delete(`${deleteCareFacility}`,{data: JSON.stringify(request)});
		  if(response.data.isSuccess){
			setDeleteOpen((preState) => !preState );
			setOpen(prevState => !prevState);
			seterrormodalOpen(false);
		  }	
		  else if(!response.data.isSuccess)	{
			seterrormodalOpen(true);
		  } 
		} catch (err) {
			console.log(err.message);
			seterrormodalOpen(true);
		}
	}

	const getDeleteRequestObj =() =>{
		return {
			careFacilityId : deleteRow.id,
			updatedBy : storeuser.email ? storeuser.email : ""
		}
	}

	const handleChangeSearchText = (e) =>{
		setRstPagination(!resetPagination);
		let searchValue = false ;
		let accountNumber = false ;
		let address = false;
		let companyName = false ;
		let parentCompany = false;
		let isParent = false;
		let isChild = false;
		let isStandAlone = false;
		let createdDate = false;
		let contactPerson = false;
		let numberOfUsers = false ;
		let createdBy = false;
		
		const newdata = careFacilities.filter( row => {
		accountNumber = row.accountNumber && row.accountNumber.toLowerCase().includes(e.target.value.toString().toLowerCase());
		address = row.address && row.address.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		companyName = row.companyName && row.companyName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		parentCompany = row.parentCompanyName && row.parentCompanyName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		isParent = row.isParent && row.isParent.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		isChild = row.isChild && row.isChild.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		isStandAlone = row.isStandAlone && row.isStandAlone.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		createdDate = row.createdDate && row.createdDate.toString().includes(e.target.value.toString());
		contactPerson = row.contactPerson && row.contactPerson.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
		numberOfUsers = row.numberOfUsers && row.numberOfUsers.toString().includes(e.target.value.toString());
		createdBy = row.createdBy && row.createdBy.toString().includes(e.target.value.toString());
			
		if(accountNumber){
			searchValue = accountNumber
		}
		else if(address){
			searchValue = address
		}
		else if(companyName){
			searchValue = companyName
		}
		else if(parentCompany){
			searchValue = parentCompany
		}
		else if(isParent){
			searchValue = isParent
		}
		else if(isChild){
			searchValue = isChild
		}
		else if(isStandAlone){
			searchValue = isStandAlone
		}
		else if(createdDate){
			searchValue = createdDate
		}
		else if(contactPerson){
			searchValue = contactPerson
		}
		else if(numberOfUsers){
			searchValue = numberOfUsers
		}
		else{
			searchValue = createdBy
		}
		return searchValue;
	})
	 setRecords(newdata)
	}

    return (
		<div style={{  margin:'10px', borderTop:'none'}}>
            <ActiveCounts showNote={false}/>

		{loading && (
        <>
          <Backdrop
            sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading... </span>
          </Backdrop>
        </>
      )}
            <div style={{ display:'flex', flexDirection:'row', marginBottom:'.5rem'}} >
                
                <h2 className="header" >Care Facility Listing</h2>
                
            </div>

			<Stack
            direction="row"
            alignItems="center"
            columnGap="2rem"
            justifyContent="right"
            sx={{ width: "100%", height: "60px", m: "5px 0" }}
          >
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "right",
                justifyContent: "space-between",
              }}
            >

        <TextField type="text" variant="outlined" 
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}} 
                    placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e)}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'5px', paddingLeft: '5px', height: "40px", textAlign:"center"}
                        }} 
                    />
            </Box>
        </Stack>
            <div style={{overflowX:'auto'}}>
			<DataTable
				title=""
				columns={careFacilityColumns(handleDelete, userAccessRole)}
				data={records}
				pagination
				striped
				highlightOnHover
				customStyles={customStyle}
				paginationRowsPerPageOptions={[5,10,15,20]}
				paginationResetDefaultPage={resetPagination}
				paginationPerPage={5}
				paginationComponentOptions={{
					rowsPerPageText:'Records per page',
					rangeSeparatorText:'Out of'
				}}				
			/>
			</div>
	
			<div className="button-container">
			<div className="left-btn-container">
			<Button id="back-btn"  variant="outlined" onClick={() => { navigate('/home')}}> Back</Button>
			{userAccessRole === "Write" || userAccessRole === "Admin" ? 
			<Link to="/admin/newCareFacility"><Button id="new-btn"  variant="contained"> Add New Care Facility</Button></Link>
			: null}
			</div>
			<div>
				{records && records.length>0 ? 
				<CustomExcelExport
				filename={`CareFacility-Listings.xlsx`}
				data={records}
				headers={exportCareFacilityColumns}
				>
			</CustomExcelExport>
			:""}
			</div>	
			</div>
            
			<Modal open={open} onClose={handleClose}>
				<>
					{warning ? (
						<Box sx={style}>
							<p>{message}</p>
							<Button id="modal-close-btn" variant="contained" onClick={handleClose}>Close</Button>
						</Box>):
						(<Box sx={style}>
							<p>Are you sure you want to delete the {facilityName} ?</p>
							<Box>
								<Button className="modal-con-yes-btn" disabled={disableBtns} variant="contained" onClick={handleDeleteCareFacility}>Yes</Button>
								<Button className="modal-con-no-btn" disabled={disableBtns} variant="contained" onClick={handleClose}>No</Button>
							</Box>
					</Box>)}
				</>
			</Modal>
			<Modal open={deleteOpen} onClose={handleDeleteClose}>
				<Box sx={style} style={{width:"23%"}}>
					<IconButton  sx={{ border:'2px solid green', boxShadow:'none'}}><Check sx={{color:'green'}} /></IconButton>
					<p>Deleted successfully!</p>
					<Button id="modal-close-conf-btn" variant="contained" onClick={handleDeleteClose}>Close</Button>
				</Box>
			</Modal>
			{errormodalopen?
			<ErrorModal plzopen={true} onClose={() => seterrormodalOpen(false)} />
			:""}
		</div>
    ) ;
}

export default CareFacilityListings;
